import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {Click} from '../../../../../models/click';
import { NgOptimizedImage } from '@angular/common';
import {ParisDatePipe} from '../../../../../pipes/date/paris-date.pipe';
import {ClickService} from '../../../../../services/click/click.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {CountryService} from '../../../../../services/country/country.service';

@Component({
  selector: 'app-click-detail',
  imports: [
    ParisDatePipe,
    NgOptimizedImage
],
  templateUrl: './click-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './click-detail.component.scss'
})
export class ClickDetailComponent implements Dialog {
  click: Click | null = null;

  constructor(
    private loader: LoaderService,
    private clickService: ClickService,
    protected countryService: CountryService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.visible = false;
    this.loader.startLoading();
    this.clickService.findOneById(params.data.id, {
      groups: 'landingPage,product,offer,partner,accountManager'
    }).subscribe(click => {
      this.click = click;
      this.loader.stopLoading();
      params.visible = true;
    });
  }
}
